import getPageNumber from './getPageNumber';

const getfirstPage = (currentPage, totalPages, displayedPages) => {
  const middlePage = Math.ceil(displayedPages / 2);
  let firstPage;

  if (totalPages <= displayedPages) {
    // If the total number of pages is less than or equal to the display pages count,
    // the first page will always be 1.
    firstPage = 1;
  } else if (currentPage <= middlePage) {
    // If the current page is less than or equal to the middle page,
    // the first page will also be 1.
    firstPage = 1;
  } else if (currentPage >= totalPages - middlePage + 1) {
    // If the current page is greater than or equal to the (totalPages - middlePage + 1),
    // then the first page will be (totalPages - displayedPages + 1).
    firstPage = totalPages - displayedPages + 1;
  } else {
    // Otherwise, the first page will be the current page minus the middle page.
    firstPage = currentPage - middlePage + 1;
  }
  return firstPage;
};

const formatPaginationData = (resultsSummary, maxPages) => {
  if (maxPages < 1) {
    return {
      controls: {
        next: null,
        previous: null,
      },
      items: [],
      limit: 10,
    };
  }
  const { currStart, nextStart, numRanks, prevStart, totalMatching } = resultsSummary;
  const limit = numRanks && numRanks > 0 ? numRanks : 1;
  const totalPages = totalMatching ? Math.ceil(totalMatching / limit) : 0;
  const displayedPages = totalPages > maxPages ? maxPages : totalPages;
  const currentPage = getPageNumber(currStart, limit);
  const firstPage = getfirstPage(currentPage, totalPages, displayedPages);

  const controls = {
    next: nextStart ? {} : null,
    previous: prevStart ? {} : null,
  };

  const items = Array.from({ length: displayedPages }, (data, pageIndex) => {
    const pageNumber = pageIndex + firstPage;
    const item = {
      pageNumber: pageNumber,
      isCurrent: pageNumber == currentPage,
    };
    return item;
  });

  const pagination = {
    controls,
    items,
    limit,
  };

  return pagination;
};

export default formatPaginationData;
